module.exports = __webpack_public_path__ + "img/mango-5.1748e9b2.png";